export default __webpack_public_path__ + "static/about_mbop-ecb5953cce03f81475a663ed0f6ad472.webp";